import React, { useState, useEffect } from "react";
import { Button, Input, Table, Tabs } from "antd";
import add from "../../../Assets/svg/addButton.svg";
import deleteIcon from "../../../Assets/svg/table-action-delete.svg";
import editIcon from "../../../Assets/svg/table-action-edit.svg";
import previewIcon from "../../../Assets/svg/table-action-preview.svg";
import "./Projects.scss";
import AdminHeader from "../../components/AdminHeader/AdminHeader";
import { Header, Footer } from "antd/es/layout/layout";
import back from "../../../Assets/svg/back.svg";
import DeleteComponent from "../../components/DeleteComponent/DeleteComponent";
import NewProject from "./NewProject";
import EditProject from "./EditProject";
import PreviewProject from "./PreviewProject";
import { useNavigate } from "react-router-dom";
import { httpService } from "../../../services/httpService.service";
import MessagePopUp from "../../components/Messages/MessagePopUp";
import IconStrategy from "../../../Assets/svg/iconStrategy.svg";
import SearchIcon from "../../../Assets/svg/searchIcon.svg";
import { isAuthorized } from "../../../services/authService";
import { RolesEnum } from "../../../services/rolesEnum";
import FooterComponent from "../../components/FooterComponent/FooterComponent";
import TPMSummary from "./TPMSummary";
import VisitsOverView from "./visitOverview/VisitsOverView";
import TPMBanner from "../workspace/TPMBanner";
import SiteVisitSummary from "./SiteVisitSummary";

const { TabPane } = Tabs;

const Projects = ({
  notifications,
  setNotifications,
  unreadNotifications,
  setUnreadNotifications,
  isGuestShare,
}) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showNewProjectModal, setShowNewProjectModal] = useState(false);
  const [showEditProjectModal, setShowEditProjectModal] = useState(false);
  const [showPreviewProjectModal, setShowPreviewProjectModal] = useState(false);
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const id = localStorage.getItem("currentContractId");
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [debouncedQuery, setDebouncedQuery] = useState(search);
  const [projectToDelete, setProjectToDelete] = useState(null);
  const [selectedProject, setSelectedProject] = useState(null);
  const [message, setMessage] = useState({
    trigger: false,
    type: "",
    icon: null,
    title: "",
    text: "",
  });
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 576);
  const publicURL = process.env.REACT_APP_API_BASE_URL;
  const currentContractName = localStorage.getItem("currentContractName");

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedQuery(search);
    }, 500);

    return () => clearTimeout(timer);
  }, [search]);

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth > 576);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleTableChange = (newPagination) => {
    fetchProjects(newPagination.current, newPagination.pageSize);
  };

  const fetchProjects = async (current, pageSize, search = "") => {
    setLoading(true);
    httpService.get(
      `/api/Projects/getAll?contractId=${id}&pageNumber=${current}&pageSize=${pageSize}&search=${search}&getDeletedOnly=false`,
      (response) => {
        const projectsData = response.data.map((project) => ({
          key: project?.id,
          projectName: project?.projectName,
          description: project?.description,
          locations: project?.projectDetails?.locations.map(
            (location) => location.name
          ),
          countryName: project?.projectDetails?.country?.stateName || "N/A",
          ...project,
          state: project?.projectDetails?.states[0]?.stateName || "N/A",
          ...project,
        }));
        console.log(response);
        localStorage.setItem(
          "Contract-startDate",
          response?.data?.[0]?.projectDetails?.contract?.contractStartDate
        );
        localStorage.setItem(
          "Contract-endDate",
          response?.data?.[0]?.projectDetails?.contract?.contractEndDate
        );

        setProjects(projectsData);
        setPagination((prevPagination) => ({
          ...prevPagination,
          current: response.metaData.pageNumber,
          pageSize: response.metaData.pageSize,
          total: response.metaData.totalItemCount,
        }));

        setLoading(false);
      },
      (error) => {
        console.error("Error fetching projects:", error);
        setLoading(false);
      }
    );
  };

  useEffect(() => {
    fetchProjects(pagination.current, pagination.pageSize, debouncedQuery);
  }, [id, debouncedQuery]);

  const handleAddProject = async () => {
    fetchProjects(pagination.current, pagination.pageSize);
  };

  const handleDeleteProject = async (projectId) => {
    try {
      setLoading(true);
      const params = [
        {
          id: projectId,
          isDeleted: false,
        },
      ];
      httpService.delete(
        `/api/Projects/deleteProjects`,
        JSON.stringify(params),
        (response) => {
          const message =
            response.message ||
            "The project has been deleted from your database.";
          setMessage({
            trigger: true,
            type: "success",
            icon: IconStrategy,
            title: "Project deleted successfully!",
            text: message,
          });
          fetchProjects(pagination.current, pagination.pageSize);
          setShowDeleteModal(false);
        },
        (error) => {
          const errorMessage =
            error?.errors?.[0]?.message ||
            error?.message ||
            "We had a problem deleting this project from your database, please try again.";
          setMessage({
            trigger: true,
            type: "danger",
            icon: IconStrategy,
            title: "Oops! A problem has occurred!",
            text: errorMessage,
          });
          setLoading(false);
        }
      );
    } catch (error) {
      const errorMessage =
        error ||
        "We had a problem deleting this project from your database, please try again.";
      setMessage({
        trigger: true,
        type: "danger",
        icon: IconStrategy,
        title: "Oops! A problem has occurred!",
        text: errorMessage,
      });
      setLoading(false);
    }
    setMessage({
      trigger: false,
    });
  };

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    setPagination({ ...pagination, current: 1 });
  };

  const goBack = () => {
    navigate("/dashboard/contracts");
  };

  const rowClickHandler = (record) => {
    onProjectClick(record);
  };

  const onProjectClick = (record) => {
    const projectId = record.id;
    const projectName = record?.projectName;
    localStorage.setItem("currentProjectID", projectId);
    localStorage.setItem("projectRoundName", projectName);

    if (isGuestShare) {
      navigate({
        pathname: "/project/dashboard",
        search: `?projectId=${projectId}&projectName=${projectName}`,
      });
    } else {
      // F-01 — every authenticated role lands on the role-based home screen.
      navigate("/project/home");
    }
  };

  const handleEdit = (record) => {
    setSelectedProject(record?.id);
    setShowEditProjectModal(true);
  };

  const columns = [
    {
      title: <span className="styledTitle">Project Round Name</span>,
      dataIndex: "projectName",
      key: "projectName",
      sorter: (a, b) => a.projectName.localeCompare(b.projectName),
      render: (text, record) => (
        <span
          className="styledDataIndex1"
          onClick={() => onProjectClick(record)}
        >
          {text}
        </span>
      ),
    },
    {
      title: <span className="styledTitle">Project Round Code</span>,
      dataIndex: "projectNumber",
      key: "projectNumber",
      sorter: (a, b) => a.projectNumber.localeCompare(b.projectNumber),
      render: (text, record) => (
        <span
          className="styledDataIndex1"
          onClick={() => onProjectClick(record)}
        >
          {text}
        </span>
      ),
    },
    {
      title: <span className="styledTitle">Description</span>,
      dataIndex: "description",
      key: "description",
      sorter: (a, b) => a.description.localeCompare(b.description),
      render: (text, record) => (
        <span
          className="styledDataIndex3"
          onClick={() => onProjectClick(record)}
        >
          {text}
        </span>
      ),
    },
    {
      title: <span className="styledTitle">Country</span>,
      dataIndex: "countryName",
      key: "countryName",
      sorter: (a, b) => a.countryName.localeCompare(b.countryName),
      render: (text, record) => (
        <span
          className="styledDataIndex3"
          onClick={() => onProjectClick(record)}
        >
          {text}
        </span>
      ),
    },

    {
      title: <span className="styledTitle">Governorate/State</span>,
      dataIndex: "state",
      key: "state",
      sorter: (a, b) => a.state.localeCompare(b.state),
      render: (text, record) => (
        <span
          className="styledDataIndex3"
          onClick={() => onProjectClick(record)}
        >
          {text}
        </span>
      ),
    },
    {
      title: <span className="styledTitle">Locations</span>,
      dataIndex: "locations",
      key: "locations",
      sorter: (a, b) =>
        a.locations.join(", ").localeCompare(b.locations.join(", ")),
      render: (locations, record) => (
        <span
          className="styledDataIndex3"
          onClick={() => onProjectClick(record)}
        >
          {locations.join(", ")}
        </span>
      ),
    },
    {
      title: <span className="styledTitle"></span>,
      key: "action",
      fixed: isLargeScreen && projects.length > 0 ? "right" : undefined,
      render: (text, record) => (
        <div className="actionDiv">
          <img
            src={previewIcon}
            style={{ cursor: "pointer" }}
            onClick={() => {
              setSelectedProject(record);
              setShowPreviewProjectModal(true);
            }}
          ></img>
          {isAuthorized([RolesEnum.ProjectManager, RolesEnum.SystemAdmin]) && (
            <img
              src={editIcon}
              style={{ cursor: "pointer" }}
              onClick={() => handleEdit(record)}
            />
          )}
          {isAuthorized([RolesEnum.ProjectManager, RolesEnum.SystemAdmin]) && (
            <img
              src={deleteIcon}
              style={{ cursor: "pointer" }}
              onClick={() => {
                setShowDeleteModal(true);
                setProjectToDelete(record?.id);
              }}
            ></img>
          )}
        </div>
      ),
    },
  ];

  return (
    <div>
      <MessagePopUp
        trigger={message.trigger}
        type={message.type}
        icon={message.icon}
        messageTitle={message.title}
        messageText={message.text}
      />
      {!isGuestShare && (
        <Header
          className="adminHeader "
          style={{ minHeight: "0 !important", padding: "0px !important" }}
        >
          <div
            style={{ display: "flex" }}
            onClick={() => {
              // localStorage.removeItem("roleId");
              goBack();
            }}
          >
            <img src={back} style={{ cursor: "pointer" }}></img>{" "}
            <span className="backText">Go back to contracts</span>
          </div>
          <AdminHeader
            notifications={notifications}
            setNotifications={setNotifications}
            unreadNotifications={unreadNotifications}
            setUnreadNotifications={setUnreadNotifications}
          >
            {" "}
          </AdminHeader>
        </Header>
      )}
      {publicURL !== "https://shareapi.tpmready.com" ? (
        // The page banners are gone platform-wide, but this is the one page whose
        // header shows no breadcrumb, so the contract stays named — as a single
        // line rather than a 200px band.
        <div className="projectsContractName">
          {currentContractName || "TPM Project Rounds/Visiting Rounds"}
        </div>
      ) : (
        <TPMBanner heading="Third-Party Monitoring (TPM) for the UNICEF & WHO SHARE Project" />
      )}
      <div className="projectsTabs">
        <Tabs
          defaultActiveKey={isGuestShare ? "2" : "1"}
          className="custom-tabs1"
          tabBarGutter={40}
        >
          <TabPane tab="Project Rounds" key="1">
            <div style={{ background: "#F8F8F8" }}>
              <div className="mainDivProjects">
                <div className="userManagementHeader">
                  <div className="userManagementHeaderFirst">
                    <span className="userManagementHeaderText">
                      My Project Rounds
                    </span>
                  </div>
                  <div className="userManagementHeaderSecond">
                    {isAuthorized([
                      RolesEnum.ProjectManager,
                      RolesEnum.SystemAdmin,
                    ]) && (
                      <Button
                        className="addButtonTPM"
                        onClick={() => setShowNewProjectModal(true)}
                      >
                        <img src={add} alt="Add" /> Add New Project Round
                      </Button>
                    )}
                  </div>
                </div>

                <div className="membersText">
                  Select a round to see the progress of your project
                </div>

                <div className="filtersWrapper">
                  <span style={{ fontWeight: "bold" }}>Search</span>
                  <Input
                    placeholder="Search by project round name..."
                    value={search}
                    allowClear
                    suffix={<img src={SearchIcon} alt="Search" />}
                    onChange={handleSearchChange}
                  />
                </div>

                <div style={{ overflowX: "auto", marginTop: "20px" }}>
                  <Table
                    dataSource={projects}
                    columns={projects?.length > 0 ? columns : []}
                    className="tableTPM"
                    loading={loading}
                    style={{ cursor: "pointer" }}
                    scroll={{ x: "max-content" }}
                    pagination={{
                      current: pagination.current,
                      pageSize: pagination.pageSize,
                      total: pagination.total,
                      showSizeChanger: true,
                    }}
                    onChange={handleTableChange}
                    onRow={(record) => ({
                      onClick: (event) => {
                        if (
                          !event.target.closest(".ant-table-cell:last-child")
                        ) {
                          rowClickHandler(record);
                        }
                      },
                    })}
                  />
                </div>
              </div>
            </div>
            <Footer>
              <FooterComponent></FooterComponent>
            </Footer>
          </TabPane>

          <TabPane tab="TPM Summary" key="2">
            <TPMSummary />
          </TabPane>
          <TabPane tab="Visits Overview" key="3">
            <VisitsOverView />
          </TabPane>
          <TabPane tab="Site Visit Summary" key="4">
            <SiteVisitSummary />
          </TabPane>
        </Tabs>
      </div>
      <DeleteComponent
        visible={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        text={
          "You're about to delete this project. This action can’t be undone."
        }
        header={"Delete Project"}
        onConfirm={() => handleDeleteProject(projectToDelete)}
        loading={loading}
      />
      <NewProject
        visible={showNewProjectModal}
        onClose={() => setShowNewProjectModal(false)}
        onSubmit={handleAddProject}
        setMessage={setMessage}
      />
      <EditProject
        visible={showEditProjectModal}
        onClose={() => setShowEditProjectModal(false)}
        projectId={selectedProject}
        onSubmit={handleAddProject}
        setMessage={setMessage}
      />
      <PreviewProject
        visible={showPreviewProjectModal}
        onClose={() => setShowPreviewProjectModal(false)}
        project={selectedProject}
      />
    </div>
  );
};
export default Projects;
